import { StaticBannerContainer } from './styled-components.js'
import {
  staticBannerStyleOptions,
  staticBannerVariantOptions
} from './constants.js'
import PropTypes from 'prop-types'

const StaticBannerComponent = ({
  variant = staticBannerVariantOptions.NEUTRAL,
  message
}) => {
  const selectedVariant = staticBannerStyleOptions[variant]

  const Icon = () => selectedVariant.icon

  return (
    <StaticBannerContainer variantStyles={selectedVariant}>
      <Icon />
      <p>{message}</p>
    </StaticBannerContainer>
  )
}

StaticBannerComponent.propTypes = {
  variant: PropTypes.oneOf(Object.values(staticBannerVariantOptions)),
  message: PropTypes.string
}

export default StaticBannerComponent
